<template>
  <v-page-content>
    <main-statistic :loaded="commonStatisticLoaded"></main-statistic>
    <geography-statistic :loaded="regionsDistributionLoaded"/>
    <districts-statistic />
    <classes-statistic :loaded="classesStatsLoaded"></classes-statistic>
    <olympic-stats :loaded="olympicStatsLoaded"></olympic-stats>
  </v-page-content>
</template>

<script>
import MainStatistic from '@/components/statistic/Main.vue'
import ClassesStatistic from '@/components/statistic/ClassesStats.vue'
import GeographyStatistic from '@/components/statistic/Geography.vue'
import DistrictsStatistic from '@/components/statistic/Districts.vue'
import OlympicStats from '@/components/statistic/OlympicsStats.vue'

export default {
  name: 'Statistics',
  components: {
    GeographyStatistic,
    MainStatistic,
    OlympicStats,
    DistrictsStatistic,
    ClassesStatistic
  },
  data() {
    return {
      regionsDistributionLoaded: true,
      commonStatisticLoaded: true,
      olympicStatsLoaded: true,
      classesStatsLoaded: true
    }
  }
}
</script>

<style scoped>

</style>
